module.exports = __webpack_public_path__ + "static/media/Poppins-ExtraBold-800.d76ccb1a.ttf";